module.exports = __webpack_public_path__ + "static/img/6.4c5dd5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/6.png
// module id = q4tf
// module chunks = 0